<div>
  <img
    [src]="haveProblem ? '/assets/triangle.svg' : '/assets/circle.svg'"
    alt="analysis-shape"
  />
</div>
